import React, { useEffect, useRef, useState } from 'react';
import { PostcodeSuggestionsProps } from '../types';

import trackEvent from '../../../../../helpers/gtm/eventPush';

const PostcodeLookupSuggestions: React.FC<PostcodeSuggestionsProps> = (
  props,
) => {
  const {
    handleSelect,
    isMobile,
    localisations,
    resetSuggestions,
    searchValue,
    showManualEntry,
    suggestions,
    trackingContext,
  } = props;

  // State management
  const [selectedAddress, setSelectedAddress] = useState<any | null>(null);
  const selectRef = useRef<HTMLSelectElement>(null);

  // Helpful variables
  const selectSize = isMobile ? 1 : 5;
  const hasSuggestions = suggestions.length > 0;

  // Auto focus on the address results
  useEffect(() => {
    if (hasSuggestions && selectRef.current) {
      selectRef.current.focus();
    }
  }, [hasSuggestions]);

  // Function to handle option select
  const handleSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ): void => {
    const address = suggestions[event.target.value];
    setSelectedAddress(address);
    handleSelect(address);
  };

  // Function to handle find address button click
  const handleFindButtonClick = (): void => {
    if (!selectedAddress) {
      return selectRef.current?.focus();
    }
    handleSelect(selectedAddress);
    return resetSuggestions();
  };

  // Function to handle select invalid
  const handleSelectInvalid = (): void => {
    trackEvent({
      category: 'Form error',
      action: `${trackingContext}_st_1:select#postcodeLookup`,
      label: `Please select your address from the list|field=${searchValue}`,
    });
  };

  // Function to handle manual entry button click
  const handleManualButtonClick = (): void => {
    showManualEntry({ track: true });
  };

  return (
    <>
      {hasSuggestions ? (
        <div className="address_postcode__results">
          {isMobile ? (
            <div className="address_postcode__validation">
              Please select your address from the list
            </div>
          ) : null}
          <select
            ref={selectRef}
            onChange={handleSelectChange}
            onInvalid={handleSelectInvalid}
            name="address-postcode-results"
            size={selectSize}
            required={true}
            aria-label="Select your address"
          >
            {isMobile ? <option>Select your address</option> : null}
            {[...suggestions].map((item, index) => (
              <option key={index} value={index}>
                {item.name}
              </option>
            ))}
          </select>
        </div>
      ) : null}

      {!isMobile ? (
        <>
          {hasSuggestions ? (
            <div className="address_postcode__validation">
              Please confirm the address
            </div>
          ) : null}
          <div className="address_postcode__action">
            {hasSuggestions ? (
              <button
                onClick={handleFindButtonClick}
                type="button"
                className="button button--secondary button--postcode button--action"
              >
                Confirm address
              </button>
            ) : null}
            <button
              onClick={handleManualButtonClick}
              type="button"
              className="autosuggest__manual-button"
            >
              {localisations?.address_not_listed}
            </button>
          </div>
        </>
      ) : null}
    </>
  );
};

export default PostcodeLookupSuggestions;
